/**
 * Removes built-in epx-flow groups that are not used by SFD.
 * Uses the chain-of-responsibility pattern to filter out unwanted groups.
 */

const HIDDEN_GROUPS = new Set([
  'loopCharacteristics', // Loop / Multi-Instance — not used in SFD
]);

export class SfdGroupFilterProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable() {
    return true; // applies to all element types
  }

  getGroups(element, existingGroups) {
    // Chain pattern: return a function that filters groups
    return (groups) => groups.filter(g => !HIDDEN_GROUPS.has(g.id));
  }
}
